import { render, staticRenderFns } from "./BenefitsInformation.vue?vue&type=template&id=45f25fee&scoped=true&"
import script from "./BenefitsInformation.vue?vue&type=script&lang=js&"
export * from "./BenefitsInformation.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsInformation.vue?vue&type=style&index=0&id=45f25fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f25fee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow})
